// extracted by mini-css-extract-plugin
export default {"container":"Card2_container__trQos","field":"Card2_field__l370B"};